import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
    Box,
    Checkbox,
    InputAdornment,
    MenuItem,
    OutlinedInput,
    TextField,
} from "@material-ui/core";
import { REI_ADDR, REI_LOCK } from '../../abis/address'
import ERC20ABI from '../../abis/ERC20ABI.json'
import LockABI from '../../abis/LockABI.json'
import PancakePairABI from '../../abis/PancakePairABI.json';
import Modal from 'react-modal';
import axios from 'axios';
import { BsChevronDown, BsChevronUp } from 'react-icons/bs'
import { CgArrowsExchangeAlt } from 'react-icons/cg'
import { MdOutlineClose } from 'react-icons/md'
import { Skeleton } from "@material-ui/lab";
import { ethers } from "ethers";
import { useWeb3Context } from "../../hooks/web3Context";

const customStyles = {
    content: {
        top: 'calc(50%)',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        maxHeight: 'calc(100vh - 40px)',
        width: '100%',
        maxWidth: '500px',
        transform: 'translate(-50%, -50%)',
        fontFamily: 'Open Sans',
        borderRadius: '8px',
        border: 'none',
        color: 'white',
        backgroundColor: 'rgba(25, 43, 68, 1)',
        fontFamily: 'Open Sans'
    },
};

const customStyles1 = {
    content: {
        top: 'calc(50%)',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        width: '100%',
        maxWidth: '500px',
        transform: 'translate(-50%, -50%)',
        fontFamily: 'Open Sans',
        borderRadius: '8px',
        border: 'none',
        backgroundColor: 'rgba(25, 43, 68, 1)',
        fontFamily: 'Open Sans',
        color: 'white',
    },
};

const lockcompound = [
    [1135.04 / 252.24 / 252.24, 1074.30 / 252.24 / 252.24, 1010.83 / 252.24 / 252.24, 889.68 / 252.24 / 252.24],
    [1982.22 / 304.87 / 304.87, 1835.37 / 304.87 / 304.87, 1687.16 / 304.87 / 304.87, 1418.83 / 304.87 / 304.87],
]
const Pool = ({ account, pools, setNotification, tokenInfo, tokenPrice, ethPrice }) => {
    const [pending, setPending] = useState(false);

    const [modalopen, setModalOpen] = useState(false);
    const [modaldata, setModalData] = useState({ index: 0, isStake: true, balance: 0 });
    const [amount, setAmount] = useState('0');

    const [calcmodal, setCalcModal] = useState(false);
    const [calcmodalindex, setCalcModalIndex] = useState(0);
    const [calcamount, setCalcAmount] = useState('0');
    const [stakeday, setStakeDay] = useState(365);
    const [compoundday, setCompoundDay] = useState(-1);
    const [showcalcdetail, setShowCalcDetail] = useState(false);
    const [compoundcalc, setCompoundCalc] = useState(false);
    const [calcshowtype, setCalcShowType] = useState(false);
    const [showlockdetail, setShowLockDetail] = useState(-1);

    const [insufficient, setInsufficient] = useState(false);

    const { connect, hasCachedProvider, provider, chainID, connected } = useWeb3Context();

    const onConfirm = async () => {
        setPending(true);
        let temp = amount.split('.')[1];
        if (temp && temp.length > 10)
            temp = amount.slice(0, amount.length - 2);
        else temp = amount;
        try {
            let tx;
            const LockContract = new ethers.Contract(REI_LOCK, LockABI, provider.getSigner());
            if (modaldata.isStake) {
                tx = await LockContract.deposit(ethers.utils.parseEther(temp), modaldata.index, { value: pools[modaldata.index].performanceFee });
            }
            else
                tx = await LockContract.withdraw(ethers.utils.parseEther(temp), modaldata.index, { value: pools[modaldata.index].performanceFee });
            await tx.wait();
        }
        catch (error) {
            console.log(error);
            fingureError(error);
        }
        setPending(false)
    }

    const onCompoundReward = async (i) => {
        setPending(true);
        try {
            const LockContract = new ethers.Contract(REI_LOCK, LockABI, provider.getSigner());
            const tx = await LockContract.compoundReward(i, { value: pools[i].performanceFee });
            await tx.wait();
        }
        catch (error) {
            console.log(error);
            fingureError(error);
        }
        setPending(false);
    }

    const onHarvestReward = async (i) => {
        setPending(true);
        try {
            const LockContract = new ethers.Contract(REI_LOCK, LockABI, provider.getSigner());
            const tx = await LockContract.claimReward(i, { value: pools[i].performanceFee });
            await tx.wait();
        }
        catch (error) {
            console.log(error);
            fingureError(error);
        }
        setPending(false);
    }

    const onCompoundReflection = async (i) => {
        setPending(true);
        try {
            const LockContract = new ethers.Contract(REI_LOCK, LockABI, provider.getSigner());
            const tx = await LockContract.compoundDividend(i, { value: pools[i].performanceFee });
            await tx.wait();
        }
        catch (error) {
            console.log(error);
            fingureError(error);
        }
        setPending(false);
    }

    const onHarvestReflection = async (i) => {
        setPending(true);
        try {
            const LockContract = new ethers.Contract(REI_LOCK, LockABI, provider.getSigner());
            const tx = await LockContract.claimDividend(i, { value: pools[i].performanceFee });
            await tx.wait();
        }
        catch (error) {
            console.log(error);
            fingureError(error);
        }
        setPending(false);
    }

    const onApproveContract = async () => {
        setPending(true);
        try {
            const tokenContract = new ethers.Contract(REI_ADDR, ERC20ABI, provider.getSigner());
            const tx = await tokenContract.approve(REI_LOCK, "115792089237316195423570985008687907853269984665640564039457584007913129639935");
            await tx.wait();
        }
        catch (error) {
            console.log(error);
            fingureError(error);
        }
        setPending(false);
    }

    function numberWithCommas(x) {
        if (!x) return;
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const CalculateRate = (index) => {
        if (compoundcalc)
            return Number(stakeday * pools[index]?.rate * pools[index]?.rate * lockcompound[index][compoundday] / 36500);
        return Number(stakeday * pools[index]?.rate / 36500);
    }

    const inputNumberFormat = (str) => {
        if (!str.length) {
            return '0';
        }

        let temp = str.split('.')[0];
        if (temp === '00' || str === '0')
            return '0';
        else if (temp === '0' && str.includes('.'))
            return str
        else
            return (str.replace(/^0+/, ''));
    }

    const fingureError = (error) => {
        if (error.code === "UNPREDICTABLE_GAS_LIMIT") {
            const list = error.message.split(',');
            for (let i = 0; i < list.length; i++) {
                if (list[i].includes('message')) {
                    let msg = String(list[i]).replaceAll('"', '');
                    msg.replaceAll('"\"', '');
                    msg.replaceAll('message:', '');
                    msg.replaceAll('}', '');
                    setNotification({ type: 'error', title: msg.split(':')[1].toUpperCase(), detail: msg.split(':')[2] })
                    break;
                }
            }
        }
        else
            setNotification({ type: 'error', title: 'Error', detail: error.message })
    }
    useEffect(() => {
        if (amount < 0 || amount > modaldata.balance)
            setInsufficient(true);
        else setInsufficient(false);
    }, [amount, modaldata])
    return (
        <StyledContainer>
            <Box>
                <Modal
                    isOpen={modalopen}
                    onRequestClose={() => setModalOpen(false)}
                    style={customStyles1}
                    contentLabel="Example Modal"
                >

                    <Box display={'flex'} justifyContent={'space-between'} mb={'20px'} fontSize={'24px'} py={'20px'} borderBottom={'2px solid rgb(100,100,100)'}>
                        <Box color={'#2ddd4d'}>
                            {modaldata.isStake ? 'Stake Tokens' : 'Withdraw Tokens'}
                        </Box>
                        <CloseButton onClick={() => setModalOpen(false)}><MdOutlineClose /></CloseButton>
                    </Box>
                    <Box display={'flex'} justifyContent={'end'} fontSize={'18px'} mb={'5px'}>
                        {modaldata.isStake ? 'Balance' : 'Staked Amount'} : {modaldata.balance}
                    </Box>
                    <CustomInput className="amountinput" type="number" value={amount.toString()}
                        endAdornment={
                            <InputAdornment position="start">
                                <Box
                                    style={{ cursor: "pointer", background: "transparent", border: '1px solid #2ddd4d', color: 'white' }}
                                    color={"white"}
                                    padding={"10px"}
                                    borderRadius={"10px"}
                                    fontSize={"18px"}
                                    onClick={() => { setAmount(modaldata.balance.toString()) }}
                                >
                                    MAX
                                </Box>
                            </InputAdornment>
                        }
                        onKeyPress={(event) => {
                            if ((event?.key === '-' || event?.key === '+')) {
                                event.preventDefault();
                            }
                        }}
                        onChange={(event) => {
                            setAmount(event.target.value);
                        }} />
                    {insufficient ? <Box color={'tomato'} display={'flex'} justifyContent={'end'} mt={'5px'} fontWeight={'700'} fontSize={'14px'}>
                        Insufficient Balance
                    </Box> : ''}
                    <ModalActions>
                        <StyledButton onClick={() => setModalOpen(false)} style={{ width: '48%' }}>Cancel</StyledButton>
                        <StyledButton disabled={insufficient || pending} onClick={() => onConfirm()} style={{ width: '48%' }}>Confirm</StyledButton>
                    </ModalActions>
                </Modal>

                <Modal
                    isOpen={calcmodal}
                    onRequestClose={() => setCalcModal(false)}
                    style={customStyles}
                    contentLabel="Example Modal"
                >
                    <Box display={'flex'} justifyContent={'space-between'} mb={'20px'} fontSize={'24px'} py={'20px'} borderBottom={'2px solid rgb(100,100,100)'}>
                        <Box color={'#2ddd4d'}>
                            ROI Calculator
                        </Box>
                        <CloseButton onClick={() => setCalcModal(false)}><MdOutlineClose /></CloseButton>
                    </Box>
                    <Box display={'flex'} justifyContent={'space-between'} fontSize={'18px'} mb={'5px'} >
                        <Box >
                            = {calcshowtype ? numberWithCommas((Number(calcamount) / tokenPrice).toFixed(2)) :
                                numberWithCommas(Number(tokenPrice * Number(calcamount)).toFixed(2))} {calcshowtype ? 'REIT' : 'USD'}
                        </Box>
                        <Box>
                            Balance : {calcshowtype ? numberWithCommas(Number(tokenInfo.balance * tokenPrice).toFixed(2)) :
                                numberWithCommas(Number(tokenInfo.balance).toFixed(2))}
                        </Box>
                    </Box>
                    <CustomInput className="amountinput" type="number" value={calcamount.toString()}
                        endAdornment={
                            <InputAdornment position="start">
                                <Box display={'flex'} alignItems={'center'}>
                                    <Box fontSize={'14px'} mr={'5px'}>{calcshowtype ? 'USD' : 'REIT '}</Box>
                                    <Box mr={'20px'} fontSize={'32px'} style={{ cursor: 'pointer' }} onClick={() => setCalcShowType(!calcshowtype)}>
                                        <CgArrowsExchangeAlt />
                                    </Box>
                                    <Box
                                        style={{ cursor: "pointer", background: "transparent", border: '1px solid #2ddd4d', color: 'white' }}
                                        color={"white"}
                                        padding={"10px"}
                                        borderRadius={"10px"}
                                        fontSize={"18px"}
                                        onClick={() => {
                                            setCalcAmount(calcshowtype ? tokenInfo.balance * tokenPrice :
                                                tokenInfo.balance)
                                        }}
                                    >
                                        MAX
                                    </Box>
                                </Box>
                            </InputAdornment>
                        }
                        onKeyPress={(event) => {
                            if ((event?.key === '-' || event?.key === '+')) {
                                event.preventDefault();
                            }
                        }}
                        onChange={(event) => {
                            if (event.target.value / 1 < 0)
                                return;

                            setCalcAmount(inputNumberFormat(event.target.value));
                        }} />
                    <Box mt={'40px'} fontSize={'18px'} color={'#2ddd4d'}>
                        STAKED FOR
                    </Box>
                    <DaySelectPanel>
                        <DaySelectCard active={stakeday === 1} onClick={() => setStakeDay(1)} width={'20%'}>1D</DaySelectCard>
                        <DaySelectCard active={stakeday === 7} onClick={() => setStakeDay(7)} width={'20%'}>7D</DaySelectCard>
                        <DaySelectCard active={stakeday === 30} onClick={() => setStakeDay(30)} width={'20%'}>30D</DaySelectCard>
                        <DaySelectCard active={stakeday === 365} onClick={() => setStakeDay(365)} width={'20%'}>1Y</DaySelectCard>
                        <DaySelectCard active={stakeday === 365 * 5} onClick={() => setStakeDay(365 * 5)} width={'20%'}>5Y</DaySelectCard>
                    </DaySelectPanel>
                    <Box mt={'40px'} fontSize={'18px'} color={'#2ddd4d'}>
                        COMPOUNDING EVERY
                    </Box>
                    <Box display={'flex'}>
                        <Checkbox checked={compoundcalc} onChange={() => {
                            if (compoundday === -1)
                                setCompoundDay(0);
                            if (compoundcalc)
                                setCompoundDay(-1);
                            setCompoundCalc(!compoundcalc)
                        }} />
                        <DaySelectPanel>
                            <DaySelectCard active={compoundday === 0} onClick={() => compoundcalc && setCompoundDay(0)} width={'25%'}>1D</DaySelectCard>
                            <DaySelectCard active={compoundday === 1} onClick={() => compoundcalc && setCompoundDay(1)} width={'25%'}>7D</DaySelectCard>
                            <DaySelectCard active={compoundday === 2} onClick={() => compoundcalc && setCompoundDay(2)} width={'25%'}>14D</DaySelectCard>
                            <DaySelectCard active={compoundday === 3} onClick={() => compoundcalc && setCompoundDay(3)} width={'25%'}>30D</DaySelectCard>
                        </DaySelectPanel>
                    </Box>

                    <Box borderRadius={'16px'} mt={'40px'} border={'1px solid #2ddd4d'} padding={'30px'} mx={'20px'} mb={'20px'}>
                        <Box fontSize={'18px'} >ROI AT CURRENT RATES</Box>
                        <Box fontSize={'28px'} mt={'10px'} fontWeight={'bold'}>${
                            numberWithCommas((calcshowtype ? Number(calcamount) * CalculateRate(calcmodalindex) :
                                Number(calcamount) * tokenPrice * CalculateRate(calcmodalindex)).toFixed(2))}</Box>
                        <Box mt={'10px'} fontWeight={'bold'}> ~ {
                            calcshowtype ? (Number(calcamount) * CalculateRate(calcmodalindex) / tokenPrice).toFixed(3) :
                                (Number(calcamount) * CalculateRate(calcmodalindex)).toFixed(3)} REIT({(CalculateRate(calcmodalindex) * 100).toFixed(2)}%)</Box>
                    </Box>

                    <Box display={'flex'} justifyContent={'center'} padding={'10px 0'}>
                        <Box display={'flex'} alignItems={'center'} style={{ cursor: 'pointer' }} onClick={() => setShowCalcDetail(!showcalcdetail)}>
                            <Box mr={'20px'} fontSize={'21px'}>
                                {showcalcdetail ? 'Hide' : 'Details'}
                            </Box>
                            {showcalcdetail ? <BsChevronUp /> : <BsChevronDown />}
                        </Box>
                    </Box>

                    {showcalcdetail ? <Box px={'20px'} fontSize={'18px'} mt={'20px'}>
                        <Box display={'flex'} justifyContent={'space-between'}>
                            <Box>APR</Box>
                            <Box>{pools[calcmodalindex]?.rate.toFixed(2)}%</Box>
                        </Box>
                        <Box display={'flex'} justifyContent={'space-between'} mt={'10px'}>
                            <Box>APY (1x daily compound)</Box>
                            <Box>0.00%</Box>
                        </Box>
                        <Box fontSize={'16px'} my={'20px'}>
                            Calculated based on current rates.<br />
                            All figures are estimates provided for your convenience only, and by no means represent guaranteed returns.
                        </Box>
                    </Box> : ''}
                </Modal>

                <LockPanel>


                    {pools && pools.map((data, i) => <Paper width={'450px'} height={'fit-content'}>
                        <Box fontSize={'20px'}>Staking Pool</Box>
                        <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} >
                            <Box>
                                <Box fontSize={'32px'}>
                                    Earn REIT
                                </Box>
                                <Box fontSize={'21px'}>
                                    Stake REIT
                                </Box>
                            </Box>
                            <Box >
                                <Box width={'40px'} height={'40px'}>
                                    <img src={'/images/rei.png'} width={'100%'} height={'100%'} alt={'rei'} />
                                </Box>
                                <Box position={'relative'} mt={'-30px'} ml={'10px'} width={'60px'} height={'60px'} >
                                    <img src={'/images/rei.png'} width={'100%'} height={'100%'} alt={'rei'} />
                                </Box>
                            </Box>
                        </Box>
                        <DataField>
                            <Box mt={'20px'} fontSize={'24px'} fontWeight={'bold'} display={'flex'} justifyContent={'space-between'}>
                                <Box color={'lightgrey'}>
                                    APR:
                                </Box>
                                {
                                    data.rate ?
                                        <Box fontWeight={'bold'} display={'flex'} alignItems={'center'} style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                setCalcModal(true)
                                                setCalcModalIndex(i)
                                            }}
                                        >
                                            <Box>
                                                {Number(data.rate === Infinity ? 0 : data.rate).toFixed(2)} %
                                            </Box>
                                            <Box ml={'5px'} mt={'8px'}>
                                                <img src='/images/operation.svg' alt='operation' />
                                            </Box>
                                        </Box>
                                        : <Skeleton variant={'text'} width={'120px'} height={'100%'} style={{ transform: 'unset' }} />
                                }

                            </Box>
                            <Box mt={'20px'} fontSize={'18px'} display={'flex'} justifyContent={'space-between'}>
                                <Box color={'lightgrey'}>
                                    Lock Duration:
                                </Box>
                                {
                                    data.duration ?
                                        <Box fontWeight={'bold'}>
                                            {Number(data.duration)}days
                                        </Box>
                                        : <Skeleton variant={'text'} width={'60px'} height={'100%'} style={{ transform: 'unset' }} />
                                }
                            </Box>
                            <Box mt={'20px'} fontSize={'18px'} display={'flex'} justifyContent={'space-between'}>
                                <Box color={'lightgrey'}>
                                    Deposit Fee:
                                </Box>
                                {
                                    data.depositFee !== undefined ?
                                        <Box fontWeight={'bold'}>
                                            {Number(data.depositFee).toFixed(2)}%
                                        </Box>
                                        :
                                        <Box mb={'5px'}>
                                            <Skeleton variant={'text'} width={'60px'} height={'100%'} style={{ transform: 'unset' }} />
                                        </Box>
                                }
                            </Box>
                            <Box fontSize={'18px'} display={'flex'} justifyContent={'space-between'}>
                                <Box color={'lightgrey'}>
                                    Withdraw Fee:
                                </Box>
                                {data.withdrawFee !== undefined ?
                                    <Box fontWeight={'bold'}>
                                        {Number(data.withdrawFee).toFixed(2)}%
                                    </Box>
                                    : <Skeleton variant={'text'} width={'60px'} height={'100%'} style={{ transform: 'unset' }} />
                                }
                            </Box>

                            <Box mt={'20px'} fontSize={'18px'} display={'flex'} justifyContent={'space-between'}>
                                <Box color={'lightgrey'}>
                                    REIT Earned
                                </Box>
                            </Box>
                            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} fontSize={'24px'}>
                                <Box>
                                    {data.pendingReward !== undefined ?
                                        <Box fontWeight={'bold'}>
                                            {numberWithCommas(Number(data.pendingReward).toFixed(3))}&nbsp;
                                        </Box>
                                        :
                                        <Box mb={'5px'}>
                                            <Skeleton variant={'text'} width={'120px'} height={'100%'} style={{ transform: 'unset' }} />
                                        </Box>
                                    }
                                    {data.pendingReward !== undefined && tokenPrice !== undefined ?
                                        <Box fontSize={'16px'}>
                                            {numberWithCommas(Number(data?.pendingReward * tokenPrice).toFixed(2))} USD
                                        </Box>
                                        :
                                        <Skeleton variant={'text'} width={'60px'} height={'100%'} style={{ transform: 'unset' }} />
                                    }
                                </Box>
                                <Box height={'80px'}>
                                    <Box>
                                        <StyledButton
                                            style={{ width: '100px', fontSize: '14px', padding: '5px' }}
                                            disabled={pending || !data?.pendingReward}
                                            onClick={() => onCompoundReward(i)}
                                        >
                                            Compound
                                        </StyledButton>
                                    </Box>
                                    <Box mt={'5px'}>
                                        <StyledButton
                                            style={{ width: '100px', fontSize: '14px', padding: '5px' }}
                                            disabled={pending || !data?.pendingReward}
                                            onClick={() => onHarvestReward(i)}
                                        >Harvest
                                        </StyledButton>
                                    </Box>
                                </Box>
                            </Box>

                            <Box mt={'20px'} fontSize={'18px'} display={'flex'} justifyContent={'space-between'}>
                                <Box color={'lightgrey'}>
                                    ETH Reflected
                                </Box>
                            </Box>
                            <Box display={'flex'} justifyContent={'space-between'} alignItems={'center'} fontSize={'24px'}>
                                <Box>
                                    {data.pendingReflection !== undefined ?
                                        <Box fontWeight={'bold'}>
                                            {numberWithCommas(Number(data.pendingReflection).toFixed(3))}&nbsp;
                                        </Box>
                                        :
                                        <Box mb={'5px'}>
                                            <Skeleton variant={'text'} width={'120px'} height={'100%'} style={{ transform: 'unset' }} />
                                        </Box>
                                    }
                                    {data.pendingReflection !== undefined && ethPrice !== undefined ?
                                        <Box fontSize={'16px'}>
                                            {numberWithCommas(Number(data?.pendingReflection * ethPrice).toFixed(2))} USD
                                        </Box>
                                        :
                                        <Skeleton variant={'text'} width={'60px'} height={'100%'} style={{ transform: 'unset' }} />
                                    }
                                </Box>
                                <Box height={'80px'}>
                                    <Box>
                                        <StyledButton
                                            style={{ width: '100px', fontSize: '14px', padding: '5px' }}
                                            disabled={pending || !data?.pendingReflection}
                                            onClick={() => onCompoundReflection(i)}
                                        >
                                            Compound
                                        </StyledButton>
                                    </Box>
                                    <Box mt={'5px'}>
                                        <StyledButton
                                            style={{ width: '100px', fontSize: '14px', padding: '5px' }}
                                            disabled={pending || !data?.pendingReflection}
                                            onClick={() => onHarvestReflection(i)}
                                        >Harvest
                                        </StyledButton>

                                    </Box>
                                </Box>
                            </Box>

                            <Box mt={'20px'} fontSize={'18px'} display={'flex'} justifyContent={'space-between'}>
                                <Box color={'lightgrey'}>
                                    REIT Staked
                                </Box>
                            </Box>
                            {data && data.allowance && account ?
                                <Box fontSize={'24px'} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
                                    {
                                        data.stakedAmount ?
                                            <Box mt={'10px'}>
                                                <Box fontWeight={'bold'}>
                                                    {numberWithCommas(Number(data.stakedAmount).toFixed(3))}
                                                </Box>
                                                <Box fontSize={'16px'}>
                                                    {numberWithCommas(Number(data.stakedAmount * tokenPrice).toFixed(2))} USD
                                                </Box>

                                            </Box> : ''
                                    }
                                    <Box width={!data.stakedAmount ? '100%' : 'unset'}>
                                        {
                                            (!data.stakedAmount) ?
                                                <StyledButton
                                                    style={{ width: '100%' }}
                                                    onClick={() => {
                                                        setModalOpen(true);
                                                        setModalData({ balance: tokenInfo.balance, index: i, isStake: true });
                                                    }}
                                                    disabled={pending}>
                                                    Stake
                                                </StyledButton> :
                                                <Action>
                                                    <ActionButton style={{ marginRight: '10px' }}

                                                        onClick={() => {
                                                            setModalOpen(true);
                                                            setModalData({ balance: tokenInfo.balance, index: i, isStake: true });
                                                        }}
                                                        disabled={pending}>
                                                        +
                                                    </ActionButton>
                                                    <ActionButton
                                                        onClick={() => {
                                                            setModalOpen(true);
                                                            setModalData({ balance: data.stakedAmount, index: i, isStake: false });
                                                        }}
                                                        disabled={pending}>
                                                        -
                                                    </ActionButton>
                                                </Action>
                                        }

                                    </Box>
                                </Box>
                                :
                                <StyledButton style={{ width: '100%' }} onClick={() => onApproveContract()} disabled={pending || !account}>
                                    Enable Contract
                                </StyledButton>
                            }
                            <Box display={'flex'} justifyContent={'center'} pt={'10px'} mt={'10px'}>
                                <Box display={'flex'} alignItems={'center'} style={{ cursor: 'pointer' }} onClick={() => setShowLockDetail(showlockdetail === i ? -1 : i)}>
                                    <Box mr={'20px'} fontSize={'21px'}>
                                        {showlockdetail === i ? 'Hide' : 'Details'}
                                    </Box>
                                    {showlockdetail === i ? <BsChevronUp /> : <BsChevronDown />}
                                </Box>
                            </Box>
                        </DataField>

                        {showlockdetail === i ? <Box mt={'20px'} fontSize={'18px'}>
                            <Box display={'flex'} justifyContent={'space-between'}>
                                <Box>Total Staked: </Box>
                                <Box>{
                                    data.totalStaked !== undefined ?
                                        <Box>{numberWithCommas(Math.round(data.totalStaked).toString())} REIT</Box> :
                                        <Skeleton variant={'text'} width={'120px'} height={'100%'} style={{ transform: 'unset' }} />
                                }</Box>
                            </Box>
                            <Box display={'flex'} justifyContent={'space-between'} mt={'10px'}>
                                <Box>Ends in: </Box>
                                <Box>{
                                    data.endBlock !== undefined ? <Box>{numberWithCommas((Number(data.endBlock)).toString())} blocks</Box> :
                                        <Skeleton variant={'text'} width={'120px'} height={'100%'} style={{ transform: 'unset' }} />
                                }</Box>
                            </Box>
                            <Box display={'flex'} justifyContent={'end'} mt={'10px'}>
                                <a
                                    href={`https://etherscan.io/address/${REI_LOCK}`}
                                    target={'_blank'}
                                    style={{ textDecoration: 'none', color: '#2ddd4d' }}
                                >
                                    See Pool Info
                                </a>
                            </Box>
                        </Box> : ''
                        }
                    </Paper>)}
                </LockPanel >
            </Box>
        </StyledContainer >
    );
};

const CloseButton = styled(Box)`
    transition : all 0.3s;
    :hover{
        opacity : 0.6;
    }
    cursor : pointer;
`;

const StyledContainer = styled(Box)`
    padding-top : 100px;
    background-image : url('/images/landing.png');
    min-height : 100vh;
    >div{
    max-width : 1100px;
    margin : 0 auto;
    padding : 0 10px;
    }
    padding-bottom : 140px;
`;
const Paper = styled(Box)`
    border : 5px solid rgb(55, 111, 221);
    border-radius : 20px;
    padding : 20px;
    color : white;
    backdrop-filter : blur(15px);
    margin-bottom : 50px;
    margin-right : 50px;
`;

const StyledButton = styled.button`
    padding : 13px 32px;
    font-weight : bold;
    font-size : 16px;
    border-radius : 2em;
    cursor : pointer;
    transition : all 0.3s;
    display : flex;
    justify-content : center;
    align-items : center;
    background-color : rgb(55, 111, 221);
    :hover{
    background-color : #2ddd4d;
    }
    font-family : 'Open Sans';
    color : white;
    border : none;
    :disabled{
        background : rgba(112,125,162,0.3);
        color : rgb(189, 194, 196);
        cursor : not-allowed;
        border : none;
    }
`

const ActionButton = styled.button`
    font-weight : bold;
    border-radius : 10px;
    cursor : pointer;
    transition : all 0.3s;
    display : flex;
    justify-content : center;
    align-items : center;
    background-color : transparent;
    :hover{
        background-color : #2ddd4d;
    }
    :disabled{
        color : rgb(200,200,200);
        border : 3px solid #2ddd4db2;
        cursor : not-allowed;
        background-color : rgba(0,0,0,0.1);
    }
    border : 3px solid #2ddd4d;
    color : white;
    font-family : 'Open Sans';
    backdrop-filter : blur(10px);
    width: 60px;
    height : 56px;
    font-size: 32px;
`;

const CustomInput = styled(OutlinedInput)`
    font-size: 20px !important;
    width: 100%;
    border-radius: 10px!important;
    border : 1px solid #2ddd4d;
    color : white!important;
    input[type=number]::-webkit-inner-spin-button, 
    input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
    }
    margin: 0; 
`;

const DaySelectPanel = styled(Box)`
    background-color: transparent;
    border-radius: 8px;
    display: inline-flex;
    border: 1px solid #2ddd4d;
    width : 100%;
    font-size : 21px;
    >div{
        display : flex;
        justify-content : center;
        align-items : center;
        cursor : pointer;
        padding : 8px 0px;
    }
    padding : 4px;
                `;

const DaySelectCard = styled(Box)`
    background-color: ${({ active }) => active ? '#2ddd4d' : 'unset'};
    color: ${({ active }) => active ? 'white' : 'unset'};
    border-radius : 8px;
    transition : all 0.2s;
`;

const LockPanel = styled(Box)`
    margin-left : 50px;
    display : flex;
    flex-wrap : wrap;
    justify-content : center;
    @media screen and (max-width : 650px){
        margin-left : 0px;
        >div{
            margin-right : 0px;
        }
    }
    @media screen and (max-width : 450px){
        >div{
            padding : 30px 20px;
        }
    }
`;

const Action = styled(Box)`
    display : flex;
    @media screen and (max-width : 500px){
        justify-content : end;
        flex-direction : column;
        >button{
                    margin-right : 0!important;
                margin-bottom : 10px;
        }
    }
`;

const ModalActions = styled(Box)`
    display : flex;
    justify-content : space-between;
    margin-top : 40px;
    @media screen and (max-width : 500px){
    }
`

const DataField = styled(Box)`
    >div{
        @media screen and (max-width : 600px)
            {
            font-size : 16px!important;
            }
        }
`;
export default Pool;
